export const images = {
	fullscreen: require('./fullscreen.png'),
	welcomeImg: require('./welcome.svg'),
	logo_sm: require('./logo_sm.png'),
	logoheader: require('./logoheader.png'),
	patientIcon: require('./patient.png'),
	edenredlog: require('./edenredlogo.svg'),
	UAE: require('./UAE.png'),
	location: require('./Location.png'),
	gift: require('./Gift.png'),
	document: require('./document.png'),
	search: require('./Search.png'),
	// doctorIcon: require('./doctor.png'),
	doctorIcon: require('./doctor.svg'),
	therapist: require('./therapist.svg'),
	hospitalisation: require('./hospitalisation.svg'),
	appointment: require('./appointment.svg'),
	Medicine: require('./Medicine.svg'),
	callInprogress: require('./call-inprogress.svg'),
	map: require('./map.png'),
	star: require('./Star fill.svg'),
	callCompleted: require('./call-completed.svg'),
	bellRing: require('./bell-ring.png'),
	firstAidKit: require('./first-aid-kit-health-care.png'),
	register: require('./register.png'),
	logo: require('./logo.png'),
	welcome: require('./welcome.png'),
	konnektivelogo: require('./konnektivelogo.png'),
	prof3: require('./prof3.png'),
	dashboardicon: require('./dashboardicon.png'),
	profileicon: require('./profileicon.png'),
	usercard: require('./usercard.png'),
	prof2: require('./prof2.png'),
	edit: require('./edit.png'),
	camera: require('./camera.png'),
	logout: require('./logout.png'),
	collapseleft: require('./collapseleft.png'),
	collapseright: require('./collapseleft.png'),
	deleteimg: require('./deleteimg.png'),
	business: require('./business.png'),
	mail: require('./mail.png'),
	phone: require('./phone.png'),
	web: require('./web.png'),
	user: require('./user.png'),
	lock: require('./lock.png'),
	deactiveimg: require('./deactiveimg.png'),
	signout: require('./signout.png'),
	k: require('./k.png'),
	upload: require('./upload.png'),
	inactiveempty: require('./inactiveempty.png'),
	inactivedelete: require('./inactivedelete.png'),
	commission: require('./commission.png'),
	affiliatemanagement: require('./affiliatemanagement.png'),
	usericon: require('./usericon.svg'),
	support_logo: require('./support_logo.png'),
	c3: require('./C3Pay.svg'),
	mappoint: require('./mappointer.svg'),
	rk: require('./RakbankLogo.svg'),
	ham: require('./ham.svg'),
	atmlocation: require('./atmheader.png'),
	filtericon: require('./filter.svg'),
	facebook: require('./facebook.svg'),
	linkedin: require('./LinkedIn.svg'),
	searchicon: require('./Search.png'),
	caution: require('./caution.png'),
	up: require('./up.svg'),
	down: require('./down.svg'),
	searchSvg: require('./searchSvg.svg'),
	adduser: require('./AddUsers.svg'),
	excel: require('./Excell.svg'),
	mol: require('./Mol.svg'),
	upload: require('./Upload.svg'),
	search: require('./Search.svg'),
	checkbox: require('./Vector.svg'),
	tickcheck: require('./tickcheck.svg'),
	Error: require('./Error.svg'),
	deleteicon: require('./deleteicon.svg'),
	plus: require('./plus.svg'),
	build: require('./build.svg'),
	lock: require('./lock.svg'),
	message: require('./message.svg'),
	mail: require('./mail.svg'),
	phone: require('./phone.svg'),
	uparrow: require('./uparrow.svg'),
	downarrow: require('./downarrow.svg'),
	adownarrow: require('./adownarrow.svg'),
	Clock: require('./Clock.svg'),
	tracking: require('./tracking.png'),
	add: require('./add.svg'),
	remove: require('./remove.svg'),
};
